/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsPayoutConfig } from '../../config/settings.config';
export interface ISettingsPayoutPluginMethods extends IPluginMethodMap {
  getSettingsPayoutSync(args?: any): any;
}

export class SettingsPayoutPlugin implements IAgentPlugin {
  readonly methods: ISettingsPayoutPluginMethods;

  constructor() {
    this.methods = {
      getSettingsPayoutSync: this.getSettingsPayoutSync.bind(this),
    };
  }

  getSettingsPayoutSync(args?: any) {
    return {
      settings: settingsPayoutConfig,
    };
  }
}
